<div *ngIf="analysis">
  <div><b>{{'Latest analysis (most recently Updated at)' | translate }}</b></div>
  <div>{{'Taken at' | translate }}: {{ analysis[0].NaytteenottoMatka.Naytteenotto.NaytteenottoHetki | date: 'dd.MM.yyyy' }}</div>
  <div *ngIf="analysis[0].NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties.nimi">
    {{'For target' | translate }}: {{ analysis[0].NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties.nimi }}
  </div>
  <div *ngIf="analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteNimi">
    {{'With name' | translate }}: {{ analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteNimi }}
  </div>
  <div *ngIf="analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteTyyppi">
    {{'With type' | translate }}: {{ analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteTyyppi }}
  </div>
  <div *ngIf="analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteYmparisto">
    {{'With environment' | translate }}: {{ analysis[0].NaytteenottoMatka.Naytteenotto.Nayte.NayteYmparisto }}
  </div>
  <div>{{'Updated at' | translate }}: {{ analysis[0].updatedAt | date: 'dd.MM.yyyy' }}</div>
</div>
